import React from "react";
import { BoxyNumbers } from "../boxy-numbers/boxy-numbers";
import { useAppSelector } from "../../../redux/store";

export const ViewCounter = () => {
  const viewCount = useAppSelector((state) => state.meta.count);
  return <BoxyNumbers value={viewCount ?? 0} />;
};
